import React from 'react';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import SEO from '../common/SEO';
import BreadCrumbOne from '../elements/breadcrumb/BreadCrumbOne';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import SectionTitle from '../elements/section-title/SectionTitle';
import PricingOne from '../component/pricing/PricingOne';
import FaqOne from '../component/faq/FaqOne';


const PricingTable = () => {

    return (
        <>
        <SEO title="Hire Resources" />
        <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />
                <BreadCrumbOne 
                title="Hire Resources"
                page="Hire Resources"
                />
                <div className="container" style={{marginTop: '20px'}}>
                    <div className="row">
                    <div className="col-xl-7 col-lg-6">
                        <div className="case-study-featured-thumb text-start">
                        <img src={process.env.PUBLIC_URL + "/images/others/case-study-4.jpg"} alt="travel" />
                        </div>
                    </div>
                    <div className="col-xl-5 col-lg-6">
                        <div className="case-study-featured">
                        <div className="section-heading heading-left">
                            <span className="subtitle">Hire Resources</span>
                            <h2 className="title">Hire Dedicated Programmers</h2>
                            <p>The dedicated development team at NewwayIT delivers exceptional custom digital solutions, making us a trusted choice for businesses globally. Our skilled developers simplify complex processes to provide cost-effective, industry-specific solutions that transform ideas into world-class products. Companies of all sizes can hire our experienced professionals to achieve their development goals while benefiting from innovation, expertise, and excellence.</p>
                            <p>NewwayIT specializes in projects across diverse technology stacks, leveraging cutting-edge advancements to deliver reliable and futuristic solutions. Partner with us to bring a modern touch to your business and witness the impact of our expertise.</p>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
                <div className="section section-padding">
                    <div className="container">
                        <SectionTitle 
                            subtitle="Hire Resources"
                            title="Find whats right for you."
                            description=""
                            textAlignment="mb-0"
                            textColor=""
                        />
                        <PricingOne />
                    </div>
                    <ul className="shape-group-3 list-unstyled">
                        <li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/bubble-4.png"} alt="shape" /></li>
                    </ul>
                </div>
                <FaqOne />
                <CtaLayoutOne />
                <FooterOne parentClass="" />
            </main>
        </>
    )
}

export default PricingTable;